import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Anime%20visual%20novel%20game%20collage%20with%20cherry%20blossom%20petals%20floating%2C%20warm%20golden%20sunset%20sky%2C%20Japanese%20school%20building%20silhouette%2C%20soft%20dreamy%20atmosphere%2C%20beautiful%20anime%20art%20style%20with%20gentle%20colors%2C%20emotional%20and%20nostalgic%20mood%2C%20clean%20composition&width=1800&height=900&seq=hero-bg-galgame&orientation=landscape"
        alt="Galgame资源网站PC - PC版Galgame下载平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-sm text-white/90">每日更新 · 资源已超过 4,620 款</span>
        </div>

        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          Galgame资源网站PC
        </h1>
        <p className="text-lg md:text-xl text-white/80 mb-3 max-w-2xl mx-auto leading-relaxed">
          最全PC版Galgame下载平台
        </p>
        <p className="text-base text-white/65 mb-8 max-w-xl mx-auto leading-relaxed">
          汇聚海量PC端Galgame游戏资源，涵盖汉化版、日文原版、补丁包及攻略。<br className="hidden sm:block" />
          Windows系统免费下载，更新及时、分类清晰，PC玩家必收藏的Galgame资源网站。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/hanhua"
            className="px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-base hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/30"
          >
            <i className="ri-download-line mr-2"></i>
            浏览汉化资源
          </Link>
          <Link
            to="/category/xinyou"
            className="px-8 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-white font-medium text-base hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-rocket-line mr-2"></i>
            查看最新上架
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 text-white/60 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-lg text-accent-400"></i>
            <span>安全检测</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-refresh-line text-lg text-accent-400"></i>
            <span>每日更新</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-group-line text-lg text-accent-400"></i>
            <span>玩家社区</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-download-cloud-2-line text-lg text-accent-400"></i>
            <span>免费下载</span>
          </div>
        </div>
      </div>
    </section>
  );
}